import styled from "styled-components";
import {getBold, getLineHeight, parseSize} from "../../../common/generic-react.functions.js";
export const LabelContainer = styled.label.attrs(({
  htmlFor
}) => htmlFor && {
  htmlFor
}).withConfig({
  displayName: "labelstyles__LabelContainer",
  componentId: "sc-11gj4la-0"
})(["color:", ";background-color:", ";", ";", ";", " ", " ", ""], ({
  color
}) => color, ({
  bgColor
}) => bgColor, ({
  size
}) => size && `font-size: ${parseSize(size)}; ${!Number(size) && typeof size === "string" ? `line-height: ${getLineHeight(size)};` : ""}`, ({
  bold
}) => getBold(bold), ({
  disabled
}) => disabled && {
  opacity: "0.5",
  cursor: "not-allowed"
}, ({
  disabled,
  clickable
}) => !disabled && clickable && {
  cursor: "pointer"
}, {
  display: "inline-flex",
  alignItems: "center",
  alignContent: "space-between",
  paddingTop: "0.25rem",
  paddingBottom: "0.25rem",
  paddingLeft: "0.5rem",
  paddingRight: "0.5rem"
});
export const LabelRequiredContainer = styled.span.withConfig({
  displayName: "labelstyles__LabelRequiredContainer",
  componentId: "sc-11gj4la-1"
})(["", " ", " ", ";"], ({
  required
}) => (required === true || required === "left") && {
  marginLeft: "0.25rem"
}, ({
  required
}) => required === "right" && {
  marginRight: "0.25rem"
}, {
  "--tw-text-opacity": "1",
  color: "rgba(185, 28, 28, var(--tw-text-opacity))"
});
